import type { PageThemeDefinition } from "../types";

/** G777.ph — 主色 #1B0D44 */
export const g7Theme: PageThemeDefinition = {
  id: "g7",
  labelKey: "robot.setting.page_theme.g7",
  preview: {
    background: "#12082E",
    cardBg: "#1B0D44",
    text: "#ffffff",
  },
  tokens: {
    background: "#12082E",
    cardBg: "#1B0D44",
    text: "#ffffff",
    textSecondary: "#B8A8D8",
    border: "#3D2870",
    headerBg: "#12082E",
    inputBg: "#1B0D44",
    messageBg: "#1B0D44",
    senderBg: "#1B0D44",
    statusOnline: "#02BA54",
    statusEnding: "#ED645F",
    starActive: "#FFE200",
    starInactive: "#4A3868",
    shadow: "rgba(0, 0, 0, 0.5)",
    hoverBg: "#261654",
    accent: "#D946EF",
    appearance: "dark",
    chatMessageText: "#FFFFFF",
    chatAgentBubbleBg: "#261654",
    chatAgentBubbleBorder: "#3D2870",
    chatUserGradientStart: "#A855F7",
    chatUserGradientEnd: "#6B21A8",
    chatUserMessageText: "#FFFFFF",
    chatInputFieldBg: "#12082E",
    chatInputText: "#FFFFFF",
    chatInputPlaceholder: "#B8A8D8",
    chatMediaBg: "#12082E",
    chatIconColor: "#FFFFFF",
    chatLinkColor: "#22D3EE",
  },
};
